import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {Ecfmg} from './ecfmg.model';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class EcfmgService extends UserModelService<Ecfmg> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'ecfmg', Ecfmg);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/ecfmg/ecfmg.service.ts